const ANALYTICS_API_URL =
  "https://trgrm8qk9a.execute-api.us-east-2.amazonaws.com/dev/events";

// Session ID: Always preserved for user activity grouping
const getSessionId = () => {
  let sessionId = sessionStorage.getItem("sessionId");
  if (!sessionId) {
    sessionId = `sess-${Date.now()}`;
    sessionStorage.setItem("sessionId", sessionId);
  }
  return sessionId;
};

export const resetAnalyticsIdentity = () => {
  localStorage.removeItem("userId");      // reset old logged-in user
  sessionStorage.removeItem("sessionId"); // force new session
};

const getUserId = () => {
  const user = localStorage.getItem("userId");
  return user && user !== "undefined" ? user : "anonymous";
};

export const Analytics = {
  logEvent: async (eventName, details = {}) => {
    try {
      const payload = {
        eventName,
        userId: getUserId(),
        sessionId: getSessionId(),
        page: window.location.pathname,
        details,
        timestamp: Date.now(),
      };

      await fetch(ANALYTICS_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      console.log("✅ Logged event:", payload);
    } catch (error) {
      console.error("❌ Error logging event:", error);
    }
  },

  // Convenience analytics events
  loginAttempt: (method = "email") =>
    Analytics.logEvent("login_attempt", { method }),

  loginSuccess: (email) => {
    localStorage.setItem("userId", email);
    Analytics.logEvent("login_success", { email });
  },

  logOut: (email) => {
    Analytics.logEvent("user_logged_out", { email });
  },

  loginFailed: (error) =>
    Analytics.logEvent("login_failed", { error }),

  signupLinkClicked: () =>
    Analytics.logEvent("signup_link_clicked"),

};
